"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProductFromBasketAnalyticsSaga = exports.removeProductFromBasketAnalytics = void 0;
const tslib_1 = require("tslib");
const effects_1 = require("redux-saga/effects");
const BasketAPI_1 = tslib_1.__importDefault(require("../../../api/basket/BasketAPI"));
const BasketActions_creators_1 = require("../actions/BasketActions.creators");
const ActionEnums_1 = require("../../../enums/ActionEnums");
function* removeProductFromBasketAnalytics(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield (0, effects_1.getContext)('aemConfiguration');
        const analyticsGoogleTagManagerData = yield (0, effects_1.call)(BasketAPI_1.default.removeProductFromBasketAnalytics, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield (0, effects_1.put)(BasketActions_creators_1.basketActions.createRemoveGoogleAnalyticsSuccessAction(analyticsGoogleTagManagerData));
        const analyticsAdobeTagManagerData = yield (0, effects_1.call)(BasketAPI_1.default.removeProductFromBasketDtm, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield (0, effects_1.put)(BasketActions_creators_1.basketActions.createRemoveAdobeAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
exports.removeProductFromBasketAnalytics = removeProductFromBasketAnalytics;
function* removeProductFromBasketAnalyticsSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.BasketActionTypes.REMOVE_PRODUCT_SUCCESS, removeProductFromBasketAnalytics);
}
exports.removeProductFromBasketAnalyticsSaga = removeProductFromBasketAnalyticsSaga;
